import axios from "@pankod/refine-simple-rest/node_modules/axios";
import { TOKEN_KEY } from "constants/environment";

export const axiosWithAuth = () => {
    const instance = axios.create();
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
        instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    return instance;
};
